module.exports = __webpack_public_path__ + "img/5.78f375f0.png";